import React, { useState, useEffect, useCallback } from "react";
import logoZuno from "../assets/zuno-logo.png";

// ─── MENSAGENS POR PERÍODO ───────────────────────────────────
const MENSAGENS = {
  manha: [
    {
      emoji: "🌅",
      titulo: "Bom dia,\n{nome}!",
      sub: "Que a sua manhã seja tão incrível\nquanto o caminho que você vai percorrer.",
      cor: "#f59e0b",
      gradiente: "linear-gradient(160deg, #78350f 0%, #0d0f2b 60%)",
      corSoft: "rgba(245,158,11,0.15)",
      corBorder: "rgba(245,158,11,0.3)",
    },
    {
      emoji: "☀️",
      titulo: "Manhã aberta,\n{nome}!",
      sub: "Cada corrida é uma nova história.\nA sua começa agora.",
      cor: "#fb923c",
      gradiente: "linear-gradient(160deg, #7c2d12 0%, #0d0f2b 60%)",
      corSoft: "rgba(251,146,60,0.15)",
      corBorder: "rgba(251,146,60,0.3)",
    },
    {
      emoji: "🌤️",
      titulo: "Pronto para\nvolar, {nome}?",
      sub: "O mundo está esperando por você.\nVamos juntos.",
      cor: "#38bdf8",
      gradiente: "linear-gradient(160deg, #0c4a6e 0%, #0d0f2b 60%)",
      corSoft: "rgba(56,189,248,0.15)",
      corBorder: "rgba(56,189,248,0.3)",
    },
  ],
  tarde: [
    {
      emoji: "🌆",
      titulo: "Boa tarde,\n{nome}!",
      sub: "A cidade pulsa, o movimento é seu.\nO Zuno está aqui com você.",
      cor: "#a855f7",
      gradiente: "linear-gradient(160deg, #3b0764 0%, #0d0f2b 60%)",
      corSoft: "rgba(168,85,247,0.15)",
      corBorder: "rgba(168,85,247,0.3)",
    },
    {
      emoji: "🚀",
      titulo: "Tarde cheia\nde destinos, {nome}!",
      sub: "Para onde você quer ir hoje?\nO Zuno te leva com segurança.",
      cor: "#06b6d4",
      gradiente: "linear-gradient(160deg, #083344 0%, #0d0f2b 60%)",
      corSoft: "rgba(6,182,212,0.15)",
      corBorder: "rgba(6,182,212,0.3)",
    },
    {
      emoji: "💜",
      titulo: "Que tarde\nboa, {nome}!",
      sub: "Você não está sozinho nessa jornada.\nEstamos juntos em cada corrida.",
      cor: "#ec4899",
      gradiente: "linear-gradient(160deg, #500724 0%, #0d0f2b 60%)",
      corSoft: "rgba(236,72,153,0.15)",
      corBorder: "rgba(236,72,153,0.3)",
    },
  ],
  noite: [
    {
      emoji: "🌙",
      titulo: "Boa noite,\n{nome}!",
      sub: "A noite tem sua própria magia.\nDeixe o Zuno guiar seu caminho.",
      cor: "#818cf8",
      gradiente: "linear-gradient(160deg, #1e1b4b 0%, #04060f 60%)",
      corSoft: "rgba(129,140,248,0.15)",
      corBorder: "rgba(129,140,248,0.3)",
    },
    {
      emoji: "✨",
      titulo: "Noite de\nestrelas, {nome}!",
      sub: "Enquanto a cidade descansa,\nalgumas histórias ainda precisam ser escritas.",
      cor: "#c084fc",
      gradiente: "linear-gradient(160deg, #2e1065 0%, #04060f 60%)",
      corSoft: "rgba(192,132,252,0.15)",
      corBorder: "rgba(192,132,252,0.3)",
    },
    {
      emoji: "🌃",
      titulo: "Bem-vindo\nde volta, {nome}!",
      sub: "A cidade nunca dorme,\ne o Zuno também não.",
      cor: "#34d399",
      gradiente: "linear-gradient(160deg, #064e3b 0%, #04060f 60%)",
      corSoft: "rgba(52,211,153,0.15)",
      corBorder: "rgba(52,211,153,0.3)",
    },
  ],
  madrugada: [
    {
      emoji: "🌌",
      titulo: "Ainda acordado,\n{nome}?",
      sub: "Os noturnos têm sua própria força.\nO Zuno respeita o seu tempo.",
      cor: "#6366f1",
      gradiente: "linear-gradient(160deg, #1e1b4b 0%, #020305 60%)",
      corSoft: "rgba(99,102,241,0.15)",
      corBorder: "rgba(99,102,241,0.3)",
    },
    {
      emoji: "🔮",
      titulo: "Hora mágica,\n{nome}!",
      sub: "Quando o mundo silencia,\nalgo especial acontece.",
      cor: "#a78bfa",
      gradiente: "linear-gradient(160deg, #2e1065 0%, #020305 60%)",
      corSoft: "rgba(167,139,250,0.15)",
      corBorder: "rgba(167,139,250,0.3)",
    },
  ],
};

function getPeriodo(hora) {
  if (hora >= 5 && hora < 12) return "manha";
  if (hora >= 12 && hora < 18) return "tarde";
  if (hora >= 18 && hora < 23) return "noite";
  return "madrugada";
}

function getMensagemAleatoria(nome, returning) {
  if (!returning) {
    return {
      emoji: "✨",
      titulo: `Bem-vindo à Zuno,\n${(nome || "").split(" ")[0]}!`,
      sub: "Sua conta está pronta.\nVamos planejar seu primeiro trajeto.",
      cor: "#38bdf8",
      gradiente: "linear-gradient(160deg, #0c4a6e 0%, #0d0f2b 60%)",
      corSoft: "rgba(56,189,248,0.15)",
      corBorder: "rgba(56,189,248,0.3)",
    };
  }
  const hora = new Date().getHours();
  const periodo = getPeriodo(hora);
  const lista = MENSAGENS[periodo];
  const msg = lista[Math.floor(Math.random() * lista.length)];
  return {
    ...msg,
    titulo: msg.titulo.replace("{nome}", nome.split(" ")[0]),
  };
}

export default function WelcomeScreen({ nome, returning = true, onContinue }) {
  const [msg] = useState(() => getMensagemAleatoria(nome || "", returning));
  const [step, setStep] = useState(0);
  const [particles, setParticles] = useState([]);

  const handleSair = useCallback(() => {
    setStep(2);
    setTimeout(() => { onContinue?.(); }, 600);
  }, [onContinue]);

  useEffect(() => {
    setParticles(Array.from({ length: 18 }, (_, i) => ({
      id: i,
      x: Math.random() * 100,
      y: Math.random() * 100,
      size: Math.random() * 3 + 1,
      delay: Math.random() * 3,
      duration: Math.random() * 4 + 3,
    })));
    const t1 = setTimeout(() => setStep(1), 100);
    const t2 = setTimeout(() => handleSair(), 3800);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [handleSair]);

  return (
    <div style={{
      position: "fixed", inset: 0, zIndex: 9999,
      background: msg.gradiente,
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      fontFamily: "'Segoe UI', system-ui, sans-serif",
      overflow: "hidden",
      opacity: step === 0 ? 0 : step === 2 ? 0 : 1,
      transform: step === 0 ? "scale(1.04)" : step === 2 ? "scale(0.96)" : "scale(1)",
      transition: "opacity 0.6s ease, transform 0.6s ease",
    }}>
      <style>{`
        @keyframes floatUp    { 0%{opacity:0;transform:translateY(0)} 20%{opacity:1} 80%{opacity:0.6} 100%{opacity:0;transform:translateY(-120px)} }
        @keyframes shimmer    { 0%,100%{opacity:0.3} 50%{opacity:1} }
        @keyframes pulse      { 0%,100%{transform:scale(1)} 50%{transform:scale(1.06)} }
        @keyframes slideUp    { from{opacity:0;transform:translateY(30px)} to{opacity:1;transform:translateY(0)} }
        @keyframes glow       { 0%,100%{box-shadow:0 0 40px var(--cor-soft)} 50%{box-shadow:0 0 80px var(--cor-soft)} }
        @keyframes ripple     { 0%{transform:scale(0.8);opacity:0.6} 100%{transform:scale(2.2);opacity:0} }
        @keyframes spin       { to{transform:rotate(360deg)} }
      `}</style>

      {/* Partículas flutuantes */}
      {particles.map(p => (
        <div key={p.id} style={{
          position: "absolute",
          left: `${p.x}%`, top: `${p.y}%`,
          width: p.size, height: p.size,
          borderRadius: "50%",
          background: msg.cor,
          opacity: 0,
          animation: `floatUp ${p.duration}s ease-in ${p.delay}s infinite`,
          pointerEvents: "none",
        }} />
      ))}

      {/* Círculo decorativo de fundo */}
      <div style={{
        position: "absolute",
        width: 400, height: 400,
        borderRadius: "50%",
        background: `radial-gradient(circle, ${msg.corSoft} 0%, transparent 70%)`,
        top: "50%", left: "50%",
        transform: "translate(-50%, -50%)",
        animation: "pulse 3s ease-in-out infinite",
        pointerEvents: "none",
      }} />

      {/* Conteúdo central */}
      <div style={{
        position: "relative", zIndex: 1,
        display: "flex", flexDirection: "column",
        alignItems: "center", gap: 28,
        padding: "0 32px",
        maxWidth: 380,
      }}>

        {/* Emoji principal com ripple */}
        <div style={{ position: "relative" }}>
          {/* Ripples */}
          {[0, 0.4, 0.8].map((delay, i) => (
            <div key={i} style={{
              position: "absolute", inset: -10,
              borderRadius: "50%",
              border: `1.5px solid ${msg.cor}`,
              opacity: 0,
              animation: `ripple 2.4s ease-out ${delay}s infinite`,
              pointerEvents: "none",
            }} />
          ))}

          {/* Círculo do emoji */}
          <div style={{
            width: 110, height: 110,
            borderRadius: "50%",
            background: msg.corSoft,
            border: `2px solid ${msg.corBorder}`,
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 52,
            animation: "pulse 2.5s ease-in-out infinite",
            boxShadow: `0 0 60px ${msg.corSoft}`,
          }}>
            {msg.emoji}
          </div>
        </div>

        {/* Logo pequeno */}
        <div style={{
          opacity: 0.5,
          animation: "slideUp 0.6s ease 0.2s both",
        }}>
          <img src={logoZuno} alt="Zuno" style={{ height: 24, objectFit: "contain" }} />
        </div>

        {/* Título */}
        <h1 style={{
          fontSize: 36, fontWeight: 900, color: "#fff",
          textAlign: "center", lineHeight: 1.15,
          margin: 0, whiteSpace: "pre-line",
          letterSpacing: -1,
          textShadow: `0 0 40px ${msg.corSoft}`,
          animation: "slideUp 0.6s ease 0.3s both",
          opacity: 0,
          animationFillMode: "both",
        }}>
          {msg.titulo}
        </h1>

        {/* Linha decorativa */}
        <div style={{
          width: 48, height: 3, borderRadius: 3,
          background: `linear-gradient(90deg, transparent, ${msg.cor}, transparent)`,
          animation: "slideUp 0.6s ease 0.4s both",
          opacity: 0,
          animationFillMode: "both",
        }} />

        {/* Subtítulo */}
        <p style={{
          fontSize: 16, color: "rgba(255,255,255,0.55)",
          textAlign: "center", lineHeight: 1.7,
          margin: 0, whiteSpace: "pre-line",
          maxWidth: 280,
          animation: "slideUp 0.6s ease 0.5s both",
          opacity: 0,
          animationFillMode: "both",
        }}>
          {msg.sub}
        </p>

        {/* Barra de progresso */}
        <div style={{
          width: "100%", height: 3,
          background: "rgba(255,255,255,0.08)",
          borderRadius: 3, overflow: "hidden",
          animation: "slideUp 0.6s ease 0.6s both",
          opacity: 0,
          animationFillMode: "both",
        }}>
          <div style={{
            height: "100%", borderRadius: 3,
            background: `linear-gradient(90deg, ${msg.cor}, ${msg.cor}88)`,
            animation: "progress 3.2s linear 0.7s both",
            width: "0%",
          }} />
          <style>{`
            @keyframes progress { from{width:0%} to{width:100%} }
          `}</style>
        </div>

        {/* Botão pular */}
        <button onClick={handleSair} style={{
          background: "transparent",
          border: `1px solid ${msg.corBorder}`,
          color: msg.cor,
          padding: "10px 28px", borderRadius: 50,
          fontSize: 13, fontWeight: 600,
          cursor: "pointer",
          animation: "slideUp 0.6s ease 0.7s both",
          opacity: 0,
          animationFillMode: "both",
          letterSpacing: 0.5,
          transition: "all 0.2s",
        }}>
          Continuar →
        </button>
      </div>
    </div>
  );
}
